/** Limits and user-facing text for the Assessor Assistant widget. */

export const MAX_MESSAGE_LENGTH = 2000;
/** The character counter appears from here (90%). */
export const COUNTER_FROM = 1800;

export const ASSISTANT_NAME = 'Assessor Assistant';

export const STRINGS = {
  launcher: 'Ask the Assessor',
  newChat: 'New chat',
  expand: 'Expand',
  restore: 'Restore size',
  close: 'Close',
  emptyTitle: 'How can I help?',
  emptyBody: 'Ask about property assessments, exemptions, and Assessor services in Los Angeles County.',
  composerLabel: 'Message the Assessor Assistant',
  placeholder: 'Ask about property assessments…',
  searching: 'Searching assessor.lacounty.gov…',
  send: 'Send message',
  stop: 'Stop generating',
  disclaimerBefore: 'AI answers may be inaccurate. Verify at ',
  conversation: 'Conversation',
  jumpToLatest: 'Jump to latest',
  sources: 'Sources',
  opensInNewTab: '(opens in a new tab)',
  moreSources: (n: number) => `+${n} more`,
  nextSteps: 'Suggested next steps',
  copy: 'Copy answer',
  copied: 'Copied to clipboard',
  helpful: 'Helpful',
  notHelpful: 'Not helpful',
  regenerate: 'Regenerate answer',
  whatWentWrong: 'What went wrong?',
  thanks: 'Thanks for your feedback.',
  tryAgain: 'Try again',
  /** Under an "unavailable" error, so a property question still has somewhere to go. */
  fallbackBefore: 'You can also look up a property in ',
  propertySearch: 'Property Search',
  fallbackMiddle: ' or call ',
  phone: '(213) 974-3211',
  stopped: 'Stopped.',
  saidPrefix: `${ASSISTANT_NAME} said:`,
  charactersLeft: (n: number) => `${n} characters left`,
  limitReached: 'Character limit reached',
};

export const SUGGESTIONS = [
  "What is the Homeowners' Exemption?",
  'How does Prop 19 work?',
  'Why did I get a supplemental tax bill?',
  'How do I request a decline-in-value review?',
];

export type FeedbackReason = 'inaccurate' | 'not_helpful' | 'wrong_source';

export const FEEDBACK_REASONS: ReadonlyArray<{code: FeedbackReason; label: string}> = [
  {code: 'inaccurate', label: 'Inaccurate'},
  {code: 'not_helpful', label: 'Not helpful'},
  {code: 'wrong_source', label: 'Wrong source'},
];

export const PROPERTY_SEARCH_URL = 'https://portal.assessor.lacounty.gov';
export const PHONE_HREF = 'tel:+12139743211';

export const GENERIC_ERROR = 'Something went wrong. Please try again.';
export const NETWORK_ERROR = 'Unable to reach the assistant. Check your connection and try again.';
